import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import formatApiError from "src/features/Navigation/utils/formatApiError";
import cmsClient from "src/services/cmsClient";

const createNavigationItem = async (payload: Record<string, unknown>) => {
	const response = await cmsClient.post<INavigationItem>(
		"/homepage/admin/mobilenavigation/",
		payload
	);

	return response.data;
};

const useCreateNavigationItem = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Navigation item created" />,
			{ hideProgressBar: true }
		);
	};

	const onError = (error: any) => {
		const message = formatApiError(error?.response?.data);
		toast.error(<CustomToast type="Error" message={message} />, {
			hideProgressBar: true
		});
	};

	const onSettled = () => {
		queryClient.invalidateQueries(["navigation-items"]);
	};

	const mutation = useMutation(createNavigationItem, {
		onSuccess,
		onError,
		onSettled
	});

	return mutation;
};

export default useCreateNavigationItem;
